// Meta (Facebook) Pixel helper for the v2 funnel. Pairs with FbPixelLoader.js
// (which injects the pixel). Fully dormant unless REACT_APP_FB_PIXEL_ID is set.
// fireLead() records the Lead event on funnel completion, deduped per leadId.

export const FB_PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID;

export function fireLead(leadId) {
  // Pixel disabled (env var not set): no-op.
  if (!FB_PIXEL_ID) return;

  if (!leadId) return;

  // Never send real events from dev/test builds — just log so we can verify
  // the call site fired.
  if (process.env.NODE_ENV !== "production") {
    console.log("[fbpixel] dev mode: would fire Lead for leadId=" + leadId);
    return;
  }

  const key = "fbpixel_fired_" + leadId;

  try {
    // Dedup: only fire once per lead, even across reloads/remounts.
    if (localStorage.getItem(key)) {
      console.log("[fbpixel] already fired for leadId=" + leadId);
      return;
    }

    if (typeof window.fbq === "function") {
      window.fbq("track", "Lead");
      // Mark fired only after an actual send.
      localStorage.setItem(key, "1");
    } else {
      // Don't set the dedup flag — a later call once fbq is loaded can record it.
      console.warn("[fbpixel] fbq not available — skipping Lead fire");
    }
  } catch (err) {
    // Tracking must never break the funnel.
    console.log("[fbpixel] Lead fire failed for leadId=" + leadId, err);
  }
}
